import React from "react";
import { Heart } from "@phosphor-icons/react";
import { usePlayer } from "../context/PlayerContext";
import { StationGrid } from "../components/StationGrid";

export default function Favorites() {
  const { favorites } = usePlayer();

  return (
    <div className="space-y-8">
      <div className="flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold/15 text-gold">
          <Heart size={24} weight="fill" />
        </span>
        <div>
          <h1 className="font-heading text-3xl font-light tracking-tight text-foreground">Your Favorites</h1>
          <p className="font-mono text-xs text-muted2">{favorites.length} saved stations</p>
        </div>
      </div>

      <StationGrid
        stations={favorites}
        loading={false}
        emptyState={
          <div className="flex flex-col items-center rounded-3xl border border-border bg-surface py-20 text-center">
            <img
              src="https://images.unsplash.com/photo-1624347443725-dac2bcc04c82"
              alt="Vintage radio"
              className="mb-6 h-44 w-44 rounded-2xl object-cover opacity-60 [mask-image:radial-gradient(circle,black,transparent_78%)]"
            />
            <p className="font-heading text-2xl font-light text-foreground">No favorites saved yet</p>
            <p className="mt-2 max-w-sm text-sm text-muted2">
              Tap the heart on any station to keep it here for easy access.
            </p>
          </div>
        }
      />
    </div>
  );
}
